// Mock data for Maison Morgane

export const heroImage = "https://customer-assets-0z36b82j.emergentagent.net/job_5dddbe82-2dfa-4c3d-89be-f8eb14e4ed92/artifacts/tnxbuqxn_IMG_0301.jpeg";
export const brushImage = "https://customer-assets-0z36b82j.emergentagent.net/job_5dddbe82-2dfa-4c3d-89be-f8eb14e4ed92/artifacts/r6yi6u05_IMG_0304.jpeg";
export const soinsPosterImage = "https://customer-assets-0z36b82j.emergentagent.net/job_5dddbe82-2dfa-4c3d-89be-f8eb14e4ed92/artifacts/dfuem4bz_IMG_0300.jpeg";
export const productsImage = "https://customer-assets-0z36b82j.emergentagent.net/job_5dddbe82-2dfa-4c3d-89be-f8eb14e4ed92/artifacts/daiqreee_IMG_0302.jpeg";
export const pricesImage = "https://customer-assets-0z36b82j.emergentagent.net/job_5dddbe82-2dfa-4c3d-89be-f8eb14e4ed92/artifacts/x4t6idoc_IMG_0303.jpeg";

// Services grille (16 soins comme sur l'affiche)
export const soinsGrille = [
  { id: 1, question: "Besoin de vous détendre ?", name: "Massage relaxant", desc: "Une véritable parenthèse de bien-être pour relâcher les tensions et vous offrir un moment rien qu'à vous.", category: "Massages", price: "55€", duration: "60 min" },
  { id: 2, question: "Envie de prendre soin de votre peau ?", name: "Soins visage", desc: "Prenez soin de votre peau avec des soins adaptés à ses besoins pour retrouver un teint frais, lumineux et éclatant.", category: "Visage", price: "59€", duration: "60 min" },
  { id: 3, question: "Besoin de prendre soin de votre corps ?", name: "Soin Corps Sublime", desc: "Un véritable moment de bien-être pour prendre soin de votre corps et vous sentir bien dans votre peau.", category: "Corps", price: "60€", duration: "60 min" },
  { id: 4, question: "Envie de prendre soin de vos pieds ?", name: "Pédicure esthétique", desc: "Un soin beauté pour des pieds doux, soignés et sublimés.", category: "Pieds", price: "30€", duration: "45 min" },
  { id: 5, question: "Un inconfort au niveau des pieds ?", name: "Pédicure médicale", desc: "Un soin professionnel pour prendre soin de vos pieds et traiter différents inconforts selon vos besoins.", category: "Pieds", price: "45€", duration: "60 min" },
  { id: 6, question: "Un problème au niveau d'un ongle ?", name: "Orthonyxie", desc: "Une technique spécifique qui permet de corriger progressivement certaines déformations de l'ongle pour votre confort et votre bien-être.", category: "Pieds", price: "25€", duration: "" },
  { id: 7, question: "Besoin de protéger ou reconstruire une zone de votre pied ?", name: "Prothèse en silicone", desc: "Une solution sur-mesure pour apporter protection, confort et améliorer votre quotidien.", category: "Pieds", price: "20€", duration: "" },
  { id: 8, question: "Envie de jolis pieds jusqu'au bout des ongles ?", name: "Vernis semi-permanent (pieds uniquement)", desc: "Pour des ongles sublimés, brillants et une tenue longue durée.", category: "Pieds", price: "25€", duration: "45 min" },
  { id: 9, question: "Envie d'un regard naturellement mis en valeur ?", name: "Rehaussement de cils", desc: "Idéal pour courber et sublimer vos cils naturels tout en gardant un résultat élégant et délicat.", category: "Regard", price: "55€", duration: "" },
  { id: 10, question: "Envie d'intensifier votre regard ?", name: "Extensions cil à cil", desc: "Pour apporter longueur et intensité à votre regard tout en conservant un résultat naturel.", category: "Regard", price: "80€", duration: "" },
  { id: 11, question: "Vous rêvez d'un regard plus intense ?", name: "Volume russe", desc: "Pour un effet plus fourni et sophistiqué qui sublime votre regard à chaque instant.", category: "Regard", price: "90€", duration: "" },
  { id: 12, question: "Peau douce et nette ?", name: "Épilation", desc: "Différentes zones sont disponibles pour une peau douce, nette et soignée.", category: "Épilation", price: "À partir de 8€", duration: "15-45 min" },
  { id: 13, question: "Une occasion spéciale ou simplement envie de vous faire belle ?", name: "Maquillage", desc: "Maquillage jour, soirée ou cérémonie pour vous mettre en valeur selon vos envies et l'occasion.", category: "Maquillage", price: "40€", duration: "" },
  { id: 14, question: "Sourire plus lumineux ?", name: "Blanchiment dentaire", desc: "Pour illuminer votre sourire et gagner en confiance.", category: "Nouveautés", price: "129€", duration: "" },
  { id: 15, question: "Une touche d'originalité ?", name: "Strass dentaire Swarovski", desc: "Apportez une touche brillante et personnalisée à votre sourire.", category: "Nouveautés", price: "À partir de 35€", duration: "" },
  { id: 16, question: "Redéfinir vos sourcils ou sublimer vos lèvres ?", name: "Microblading / Candy Lips", desc: "Une technique semi-permanente pour redessiner, restructurer et harmoniser vos sourcils ou pigmenter vos lèvres.", category: "Nouveautés", price: "250€", duration: "" }
];

// Prix détaillés par catégorie
export const tarifs = {
  visage: {
    title: "Visage Sublimé",
    items: [
      { name: "Rituel peau normale", detail: "épilation sourcils comprise", duration: "60 min", price: "59 €" },
      { name: "Rituel peau mixte", detail: "équilibre secrets d'expert", duration: "60 min", price: "59 €" },
      { name: "Rituel peau sèche", detail: "éclat & nutrition intense", duration: "60 min", price: "59 €" },
      { name: "Rituel peau grasse", detail: "purifiant, secrets d'experts", duration: "60 min", price: "59 €" },
      { name: "Rituel peau anti-âge", detail: "éclat jeunesse & fermeté", duration: "75 min", price: "65 €" },
      { name: "Rituel peau mature", detail: "éclat & vitalité, anti-âge", duration: "75 min", price: "65 €" },
      { name: "Soin visage signature", detail: "signature, secrets d'exception", duration: "90 min", price: "80 €" }
    ]
  },
  corps: {
    title: "Corps Sublimé",
    items: [
      { name: "Soin amincissant", duration: "60 min", price: "60 €" },
      { name: "Soin drainant", duration: "60 min", price: "60 €" },
      { name: "Soin raffermissant", duration: "60 min", price: "60 €" },
      { name: "Soin relaxant", duration: "60 min", price: "60 €" }
    ]
  },
  massages: {
    title: "Massages d'Exception",
    items: [
      { name: "Massage amincissant", duration: "60 min", price: "55 €" },
      { name: "Massage drainant", duration: "60 min", price: "55 €" },
      { name: "Massage raffermissant", duration: "60 min", price: "55 €" },
      { name: "Massage relaxant", duration: "60 min", price: "55 €" },
      { name: "Massage Signature Maison Morgane", duration: "90 min", price: "75 €" }
    ]
  },
  pieds: {
    title: "Beauté des Pieds",
    items: [
      { name: "Pédicure esthétique", price: "30 €" },
      { name: "Pédicure esthétique + vernis semi-permanent", price: "40 €" }
    ]
  },
  medicale: {
    title: "Pédicure Médicale Spécialisée",
    items: [
      { name: "Pédicure médicale", detail: "soins des ongles, callosités, ongles incarnés", price: "45 €" },
      { name: "Orthonyxie", detail: "à partir de", price: "25 €" },
      { name: "Prothèse en silicone", detail: "à partir de", price: "20 €" }
    ]
  },
  regard: {
    title: "Regard Sublimé",
    items: [
      { name: "Rehaussement de cils", detail: "avec teinture", price: "55 €" }
    ],
    subSections: [
      {
        title: "Extension cils à cils",
        items: [
          { name: "Pose complète", price: "80 €" },
          { name: "Retouche 2 semaines", price: "35 €" },
          { name: "Retouche 3 semaines", price: "45 €" },
          { name: "Retouche 4 semaines", price: "55 €" }
        ]
      },
      {
        title: "Extension Volume Russe",
        items: [
          { name: "Pose complète", price: "90 €" },
          { name: "Retouche 2 semaines", price: "45 €" },
          { name: "Retouche 3 semaines", price: "55 €" },
          { name: "Retouche 4 semaines", price: "65 €" }
        ]
      }
    ]
  },
  epilation: {
    title: "Épilation Parfaite",
    subtitle: "Épilation à la cire",
    items: [
      { name: "Sourcils", price: "8 €" },
      { name: "Lèvre supérieure", price: "8 €" },
      { name: "Menton", price: "8 €" },
      { name: "Lèvre + menton", price: "15 €" },
      { name: "Aisselles", price: "12 €" },
      { name: "Visage complet", price: "25 €" },
      { name: "Dos / torse", price: "30 €" },
      { name: "Demi-jambes", price: "22 €" },
      { name: "Jambes complètes", price: "28 €" },
      { name: "Maillot classique", price: "15 €" },
      { name: "Maillot brésilien", price: "20 €" },
      { name: "Maillot intégral", price: "25 €" },
      { name: "Ventre", price: "15 €" },
      { name: "Bras / avant-bras", price: "20 €" }
    ]
  },
  maquillage: {
    title: "Maquillage Élégance",
    items: [
      { name: "Maquillage de jour", price: "40 €" },
      { name: "Maquillage de soirée", price: "55 €" },
      { name: "Maquillage de cérémonies / événements", price: "75 €" },
      { name: "Maquillage mariée", price: "90 €" },
      { name: "Essai maquillage mariée", price: "60 €" },
      { name: "Forfait mariée avec essai", detail: "maquillage + essai inclus", price: "140 €" }
    ]
  },
  nouveautes: {
    title: "Nouveautés",
    subtitle: "Disponibles à partir d'Octobre / Novembre",
    items: [
      { name: "Blanchiment dentaire", price: "129 €" },
      { name: "Microblading (sourcils)", detail: "avec retouche incluse\nRetouches supplémentaires pendant la première année : 50 €\nRetouche après 1 an : 100 €", price: "250 €" },
      { name: "Candy Lips", detail: "micropigmentation des lèvres, avec retouche incluse\nRetouches supplémentaires pendant la première année : 50 €\nRetouche après 1 an : 100 €", price: "250 €" },
      { name: "Strass dentaire Swarovski", detail: "1 strass : 35 € · 2 strass : 60 € · 3 strass : 80 €\nComposition personnalisée à partir de 90 €", price: "à partir de 35 €" }
    ]
  }
};

export const infosImportantes = [
  "Tous nos soins sont réalisés par une professionnelle diplômée.",
  "Réservations uniquement sur rendez-vous.",
  "Merci de prévenir au moins 24h à l'avance pour toute annulation ou modification.",
  "Un acompte de 50% de la prestation sera demandé lors de la réservation.",
  "Les tarifs appliqués sont susceptibles d'évoluer dans le futur et font l'objet d'une offre de lancement, profitez-en !",
  "Carte de fidélité disponible.",
  "Déplacements possibles dans les maisons de soins, hôpitaux, etc."
];

export const contact = {
  instagram: "maison.morgane_",
  instagramUrl: "https://www.instagram.com/maison.morgane_",
  instagramDM: "https://ig.me/m/maison.morgane_",
  email: "maisonmorgane.lounge@gmail.com",
  whatsapp: "0470328388",
  whatsappUrl: "https://wa.me/32470328388?text=Bonjour%20Morgane%2C%20je%20souhaite%20r%C3%A9server%20une%20prestation.",
  address: "Rue du Patronage 38",
  city: "Rochefort",
  fullAddress: "Rue du Patronage 38, 5580 Rochefort",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Rue+du+Patronage+38+Rochefort",
  openingDate: "Septembre 2026"
};

export const horaires = {
  days: "Lundi au samedi",
  hours: "9 h — 19 h",
  note: "sur rendez-vous uniquement",
  opening: "Ouverture en septembre 2026"
};

export const deplacements = {
  title: "Déplacements",
  desc: "En institut privé à Rochefort, je vous accueille pour l'ensemble de mes prestations classiques (visage, corps, massages, cils, épilation, maquillage, blanchiment dentaire, microblading, candy lips, strass).",
  descBis: "Je me déplace uniquement pour la pédicure médicale, l'orthonyxie et les prothèses en silicone — en maisons de soins, homes, hôpitaux et à domicile.",
  info: "Frais de déplacement selon la distance. Contactez-moi pour un devis personnalisé."
};

export const bio = {
  photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_morgane-reserve/artifacts/l4fjfb9n_IMG_0323.jpeg",
  parcoursImg: "https://customer-assets-wrfwihn1.emergentagent.net/job_morgane-reserve/artifacts/dlyjrxab_IMG_0322.jpeg",
  name: "Morgane",
  age: 20,
  intro: "Bonjour, je suis Morgane, 20 ans, et fondatrice de Maison Morgane.",
  p1: "Passionnée par l'univers de la beauté et du bien-être, je vous accueille dans mon institut privé à Rochefort où chaque soin est réalisé avec professionnalisme, douceur et avec des produits de qualité.",
  p2: "Je réalise également de la pédicure médicale, orthonyxie et prothèse en silicone, et je me déplace dans les maisons de soins (homes, hôpitaux et même à domicile).",
  p3: "Je suis actuellement en formation de réflexologie plantaire pour pouvoir au mieux vous aider et vous satisfaire.",
  quote: "Mon objectif est simple : continuer à me former pour vous offrir des prestations de qualité, avec professionnalisme, écoute et bienveillance."
};

export const valeurs = [
  { title: "PROFESSIONNALISME", desc: "Des soins réalisés avec rigueur et expertise." },
  { title: "HYGIÈNE IRRÉPROCHABLE", desc: "Un environnement propre et sécurisé pour votre bien-être." },
  { title: "SOINS PERSONNALISÉS", desc: "Chaque cliente est unique, chaque soin est adapté à vos besoins." },
  { title: "PRODUITS DE QUALITÉ", desc: "Des produits professionnels sélectionnés pour leur efficacité." },
  { title: "INSTITUT PRIVÉ", desc: "Un lieu chaleureux, confidentiel et à votre écoute." },
  { title: "SUR RENDEZ-VOUS UNIQUEMENT", desc: "Pour vous garantir un moment privilégié et sans attente." }
];

export const diplomes = [
  "Diplôme d'esthéticienne",
  "Diplôme de pédicure médicale spécialisée",
  "Diplôme de gestion d'entreprise",
  "Future praticienne en blanchiment dentaire et strass",
  "Future praticienne en microblading et Candy Lips",
  "En formation : réflexologie plantaire"
];

export const parcours = [
  { num: "01", title: "4 années d'études en esthétique", desc: "J'ai suivi quatre années d'études à Saint-Joseph en esthétique, où j'ai appris énormément de choses. Ces années ont été la base de tout. Depuis toujours, l'esthétique est un rêve qui m'accompagne." },
  { num: "02", title: "1 année de formation intensive en pédicurie médicale spécialisée", desc: "Une année complète dédiée à la pédicurie médicale, où j'ai appris des techniques spécifiques comme l'orthonyxie et la prothèse en silicone." },
  { num: "03", title: "1 année de gestion d'entreprise", desc: "En parallèle, j'ai suivi une année de gestion d'entreprise pour acquérir toutes les compétences nécessaires à la réalisation de mon projet : Maison Morgane." },
  { num: "04", title: "Formation en réflexologie plantaire", desc: "Cette année, je me forme à la réflexologie plantaire, une méthode de massage basée sur la stimulation de zones spécifiques des pieds. Elle favorise la détente, rééquilibre le corps et l'esprit et contribue à votre bien-être global." },
  { num: "05", title: "Des formations complémentaires pour toujours évoluer", desc: "Parce que j'aime apprendre et me perfectionner, je continue de développer mes compétences avec plusieurs formations spécialisées : Microblading, Candy Lips, Blanchiment dentaire, Strass dentaires." }
];

export const infosPratiques = [
  { title: "Paiement", desc: "Cash ou paiement par QR code (Payconiq / virement instantané) sur place." },
  { title: "Acompte", desc: "Un acompte de 50 % du montant de la prestation est demandé à la réservation pour confirmer votre rendez-vous." },
  { title: "Annulation", desc: "Toute annulation ou modification doit être effectuée au minimum 24 h à l'avance." },
  { title: "Annulation tardive", desc: "En cas d'annulation à moins de 24 h, l'acompte est conservé. En cas d'absence sans prévenir, la prestation est facturée dans son intégralité." },
  { title: "Retard", desc: "En cas de retard supérieur à 15 min, la prestation pourra être écourtée ou reportée, sans réduction de tarif." },
  { title: "Arrivée à l'heure", desc: "Merci d'arriver à l'heure de votre rendez-vous afin de profiter pleinement de votre soin." },
  { title: "Accompagnants", desc: "Pour préserver la tranquillité du lieu et votre confort, l'accès à l'institut est réservé exclusivement à la personne ayant réservé. Les accompagnants ne sont pas acceptés." },
  { title: "Mineures", desc: "Les prestations pour mineures sont acceptées à partir de 16 ans avec autorisation parentale écrite. Pour certaines prestations spécifiques (microblading, candy lips, blanchiment), un âge minimum de 18 ans est requis." }
];

export const timeSlots = [
  "09:00", "10:00", "11:00", "14:00", "15:00", "16:00", "17:00", "18:00"
];
